import styled from 'styled-components'

export const FieldGridStyled = styled.div`
  display: grid;
  grid-template-columns:
    minmax(0, ${(props) => props.theme.typography.pxToRem(400)})
    minmax(0, 1fr);
  gap: ${(props) => props.theme.space.large};
`
